import React, { useState, useContext, useRef } from "react";
import "../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  tempUrlFico,
  useStateContext,
} from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import {
  Box,
  Typography,
  ButtonGroup,
  Button,
  Snackbar,
  Alert,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { Container, Card, Form, Row, Col, Table } from "react-bootstrap";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const LaporanJurnalUmum = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const tableRefNoBukti = useRef(null);
  const tableRefPerTanggal = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  const reportTemplateRefNoBukti = useRef(null);
  const reportTemplateRefPerTanggal = useRef(null);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  let nowDate = new Date();
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  const [value, setValue] = useState("perAccount");

  const [jurnalUmumsData, setJurnalUmumsData] = useState([]);
  const [isFetchError, setIsFetchError] = useState(false);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [previewPdfNoBukti, setPreviewPdfNoBukti] = useState(false);
  const [previewPdfPerTanggal, setPreviewPdfPerTanggal] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");

  const handleChangeLaporan = (event) => {
    setValue(event.target.value);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanJurnalUmum",
  });

  const generatePDFNoBukti = useReactToPrint({
    content: () => reportTemplateRefNoBukti.current,
    documentTitle: "LaporanJurnalUmum",
  });

  const generatePDFPerTanggal = useReactToPrint({
    content: () => reportTemplateRefPerTanggal.current,
    documentTitle: "LaporanJurnalUmum",
  });

  const tampilPdfPerAccount = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      setError(false);
      setOpen(false);
      setIsCetakExcel(false);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 20;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      try {
        setJurnalUmumsData([]);
        const requestBody = {
          dariTanggal,
          sampaiTanggal,
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        };

        if (value === "perAccount") {
          setPreviewPdfNoBukti(false);
          setPreviewPdfPerTanggal(false);
          const jurnalUmums = await axios.post(
            `${tempUrlFico}/jurnalUmumLaporanPerAccount`,
            requestBody
          );
          setJurnalUmumsData(jurnalUmums.data);
          setPreviewPdf(true);
        } else if (value === "perNoBukti") {
          setPreviewPdf(false);
          setPreviewPdfPerTanggal(false);
          const jurnalUmums = await axios.post(
            `${tempUrlFico}/jurnalUmumLaporanPerNoBukti`,
            requestBody
          );
          setJurnalUmumsData(jurnalUmums.data);
          setPreviewPdfNoBukti(true);
        } else {
          setPreviewPdf(false);
          setPreviewPdfNoBukti(false);
          const jurnalUmums = await axios.post(
            `${tempUrlFico}/jurnalUmumLaporanPerAccount`,
            requestBody
          );
          const responseData = jurnalUmums.data;
          const responseGroups =
            responseData && typeof responseData === "object"
              ? responseData
              : {};
          const rows = (Array.isArray(responseData)
            ? responseData
            : Object.values(responseGroups).flatMap((group) =>
                Array.isArray(group) ? group : []
              )
          )
            .filter((row) => row && typeof row === "object")
            .map((row, index) => ({ ...row, _sortIndex: index }))
            .sort((a, b) => {
              const dateA = new Date(a.tglJurnal).getTime();
              const dateB = new Date(b.tglJurnal).getTime();
              const safeDateA = Number.isNaN(dateA) ? 0 : dateA;
              const safeDateB = Number.isNaN(dateB) ? 0 : dateB;
              return safeDateA - safeDateB || a._sortIndex - b._sortIndex;
            });
          setJurnalUmumsData(rows);
          setPreviewPdfPerTanggal(true);
        }
      } catch (requestError) {
        console.error("Gagal memproses laporan jurnal umum", requestError);
        setJurnalUmumsData([]);
        setPreviewPdf(false);
        setPreviewPdfNoBukti(false);
        setPreviewPdfPerTanggal(false);
        setError(true);
        setOpen(true);
      } finally {
        setLoading(false);
        setTimeout(() => {
          tempPersenLoading = 0;
          setPersenLoading(tempPersenLoading.toString());
        }, "2000");
      }
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const textTableRight = {
    letterSpacing: "0.01px",
    textAlign: "right",
    border: "1px solid black",
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const tableLastText = {
    borderTop: "1px solid black",
    letterSpacing: "0.01px",
    border: "1px solid black",
  };

  const list = [];

  let keys = Object.keys(jurnalUmumsData);
  let tempDebet = 0;
  let totalDebet = 0;
  let tempKredit = 0;
  let totalKredit = 0;
  let tempSaldo = 0;
  let totalSaldo = 0;

  if (previewPdf) {
    for (let j = 0; j < Object.keys(jurnalUmumsData).length; j++) {
      list.push(
        <tr style={tableText}>
          <td
            style={{ fontWeight: 700, border: "1px solid black" }}
            colspan="6"
          >
            Account: {jurnalUmumsData[keys[j]][0].kodeCOA} -{" "}
            {jurnalUmumsData[keys[j]][0].namaCOA}
          </td>
        </tr>
      );
      for (let i = 0; i < jurnalUmumsData[keys[j]].length; i++) {
        let tempTglJurnal = new Date(jurnalUmumsData[keys[j]][i].tglJurnal);
        if (jurnalUmumsData[keys[j]][i].jenis === "D") {
          tempDebet += jurnalUmumsData[keys[j]][i].jumlah;
          totalDebet += jurnalUmumsData[keys[j]][i].jumlah;
          tempSaldo += jurnalUmumsData[keys[j]][i].jumlah;
          totalSaldo += jurnalUmumsData[keys[j]][i].jumlah;
        } else {
          tempKredit += jurnalUmumsData[keys[j]][i].jumlah;
          totalKredit += jurnalUmumsData[keys[j]][i].jumlah;
          tempSaldo -= jurnalUmumsData[keys[j]][i].jumlah;
          totalSaldo -= jurnalUmumsData[keys[j]][i].jumlah;
        }
        list.push(
          <tr style={tableText}>
            <td style={{ border: "1px solid black" }}>{`${tempTglJurnal
              .getDate()
              .toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}-${(tempTglJurnal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${tempTglJurnal.getFullYear()}`}</td>
            <td style={{ border: "1px solid black" }}>
              {jurnalUmumsData[keys[j]][i].noBukti}
            </td>
            <td style={{ border: "1px solid black" }}>
              {jurnalUmumsData[keys[j]][i].keterangan.slice(0, 35)}
            </td>
            {jurnalUmumsData[keys[j]][i].jenis === "D" ? (
              <>
                <td style={textTableRight}>
                  {isCetakExcel === false
                    ? jurnalUmumsData[keys[j]][i].jumlah.toLocaleString("de-DE")
                    : jurnalUmumsData[keys[j]][i].jumlah}
                </td>
                <td style={{ border: "1px solid black" }}></td>
              </>
            ) : (
              <>
                <td style={{ border: "1px solid black" }}></td>
                <td style={textTableRight}>
                  {isCetakExcel === false
                    ? jurnalUmumsData[keys[j]][i].jumlah.toLocaleString("de-DE")
                    : jurnalUmumsData[keys[j]][i].jumlah}
                </td>
              </>
            )}
            <td style={textTableRight}>
              {isCetakExcel === false
                ? tempSaldo.toLocaleString("de-DE")
                : tempSaldo}
            </td>
          </tr>
        );

        list.push(
          <tr>
            <td
              style={{ fontWeight: 700, border: "1px solid black" }}
              colspan="3"
            >
              SubTotal Account: {jurnalUmumsData[keys[j]][0].kodeCOA} -{" "}
              {jurnalUmumsData[keys[j]][0].namaCOA}
            </td>
            <td style={textTableRight}>
              {isCetakExcel === false
                ? tempDebet.toLocaleString("de-DE")
                : tempDebet}
            </td>
            <td style={textTableRight}>
              {isCetakExcel === false
                ? tempKredit.toLocaleString("de-DE")
                : tempKredit}
            </td>
            <td style={textTableRight}>
              {isCetakExcel === false
                ? tempSaldo.toLocaleString("de-DE")
                : tempSaldo}
            </td>
          </tr>
        );
        tempDebet = 0;
        tempKredit = 0;
        tempSaldo = 0;
      }
    }

    list.push(
      <tr style={{ borderTop: "1px solid black" }}>
        <td style={{ fontWeight: 700, border: "1px solid black" }} colspan="3">
          Balance:
        </td>
        <td style={textTableRight}>
          {isCetakExcel === false
            ? totalDebet.toLocaleString("de-DE")
            : totalDebet}
        </td>
        <td style={textTableRight}>
          {isCetakExcel === false
            ? totalKredit.toLocaleString("de-DE")
            : totalKredit}
        </td>
        <td style={textTableRight}>
          {isCetakExcel === false
            ? totalSaldo.toLocaleString("de-DE")
            : totalSaldo}
        </td>
      </tr>
    );
  }

  if (previewPdfNoBukti) {
    for (let j = 0; j < Object.keys(jurnalUmumsData).length; j++) {
      list.push(
        <tr style={tableText}>
          <td
            style={{ fontWeight: 700, border: "1px solid black" }}
            colspan="6"
          >
            No. Bukti: {jurnalUmumsData[keys[j]][0].noBukti}
          </td>
        </tr>
      );
      for (let i = 0; i < jurnalUmumsData[keys[j]].length; i++) {
        let tempTglJurnal = new Date(jurnalUmumsData[keys[j]][i].tglJurnal);
        if (jurnalUmumsData[keys[j]][i].jenis === "D") {
          tempDebet += jurnalUmumsData[keys[j]][i].jumlah;
          totalDebet += jurnalUmumsData[keys[j]][i].jumlah;
          tempSaldo += jurnalUmumsData[keys[j]][i].jumlah;
          totalSaldo += jurnalUmumsData[keys[j]][i].jumlah;
        } else {
          tempKredit += jurnalUmumsData[keys[j]][i].jumlah;
          totalKredit += jurnalUmumsData[keys[j]][i].jumlah;
          tempSaldo -= jurnalUmumsData[keys[j]][i].jumlah;
          totalSaldo -= jurnalUmumsData[keys[j]][i].jumlah;
        }
        list.push(
          <tr style={tableText}>
            <td style={{ border: "1px solid black" }}>{`${tempTglJurnal
              .getDate()
              .toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })}-${(tempTglJurnal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${tempTglJurnal.getFullYear()}`}</td>
            <td style={{ border: "1px solid black" }}>
              {jurnalUmumsData[keys[j]][i].noBukti}
            </td>
            <td style={{ border: "1px solid black" }}>
              {jurnalUmumsData[keys[j]][i].keterangan.slice(0, 35)}
            </td>
            {jurnalUmumsData[keys[j]][i].jenis === "D" ? (
              <>
                <td style={textTableRight}>
                  {isCetakExcel === false
                    ? jurnalUmumsData[keys[j]][i].jumlah.toLocaleString("de-DE")
                    : jurnalUmumsData[keys[j]][i].jumlah}
                </td>
                <td style={{ border: "1px solid black" }}></td>
              </>
            ) : (
              <>
                <td style={{ border: "1px solid black" }}></td>
                <td style={textTableRight}>
                  {isCetakExcel === false
                    ? jurnalUmumsData[keys[j]][i].jumlah.toLocaleString("de-DE")
                    : jurnalUmumsData[keys[j]][i].jumlah}
                </td>
              </>
            )}
            <td style={textTableRight}>
              {isCetakExcel === false
                ? tempSaldo.toLocaleString("de-DE")
                : tempSaldo}
            </td>
          </tr>
        );
      }
      list.push(
        <tr>
          <td
            style={{ fontWeight: 700, border: "1px solid black" }}
            colspan="3"
          >
            SubTotal No. Bukti: {jurnalUmumsData[keys[j]][0].noBukti}
          </td>
          <td style={textTableRight}>
            {isCetakExcel === false
              ? tempDebet.toLocaleString("de-DE")
              : tempDebet}
          </td>
          <td style={textTableRight}>
            {isCetakExcel === false
              ? tempKredit.toLocaleString("de-DE")
              : tempKredit}
          </td>
          <td style={textTableRight}>
            {isCetakExcel === false
              ? tempSaldo.toLocaleString("de-DE")
              : tempSaldo}
          </td>
        </tr>
      );
      tempDebet = 0;
      tempKredit = 0;
      tempSaldo = 0;
    }

    list.push(
      <tr style={{ borderTop: "1px solid black" }}>
        <td style={{ fontWeight: 700, border: "1px solid black" }} colspan="3">
          Balance:
        </td>
        <td style={textTableRight}>
          {isCetakExcel === false
            ? totalDebet.toLocaleString("de-DE")
            : totalDebet}
        </td>
        <td style={textTableRight}>
          {isCetakExcel === false
            ? totalKredit.toLocaleString("de-DE")
            : totalKredit}
        </td>
        <td style={textTableRight}>
          {isCetakExcel === false
            ? totalSaldo.toLocaleString("de-DE")
            : totalSaldo}
        </td>
      </tr>
    );
  }

  if (previewPdfPerTanggal) {
    let runningSaldo = 0;
    let totalPerTanggalDebet = 0;
    let totalPerTanggalKredit = 0;

    for (let i = 0; i < jurnalUmumsData.length; i++) {
      const row = jurnalUmumsData[i];
      const tempTglJurnal = new Date(row.tglJurnal);
      const jumlah = Number(row.jumlah) || 0;

      if (row.jenis === "D") {
        totalPerTanggalDebet += jumlah;
        runningSaldo += jumlah;
      } else {
        totalPerTanggalKredit += jumlah;
        runningSaldo -= jumlah;
      }

      list.push(
        <tr key={`per-tanggal-${i}-${row.noBukti}`} style={tableText}>
          <td style={{ border: "1px solid black" }}>{`${tempTglJurnal
            .getDate()
            .toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(tempTglJurnal.getMonth() + 1).toLocaleString("en-US", {
            minimumIntegerDigits: 2,
            useGrouping: false,
          })}-${tempTglJurnal.getFullYear()}`}</td>
          <td style={{ border: "1px solid black" }}>{row.noBukti}</td>
          <td style={{ border: "1px solid black" }}>
            {String(row.keterangan || "").slice(0, 35)}
          </td>
          {row.jenis === "D" ? (
            <>
              <td style={textTableRight}>
                {isCetakExcel === false
                  ? jumlah.toLocaleString("de-DE")
                  : jumlah}
              </td>
              <td style={{ border: "1px solid black" }}></td>
            </>
          ) : (
            <>
              <td style={{ border: "1px solid black" }}></td>
              <td style={textTableRight}>
                {isCetakExcel === false
                  ? jumlah.toLocaleString("de-DE")
                  : jumlah}
              </td>
            </>
          )}
          <td style={textTableRight}>
            {isCetakExcel === false
              ? runningSaldo.toLocaleString("de-DE")
              : runningSaldo}
          </td>
        </tr>
      );
    }

    list.push(
      <tr key="per-tanggal-balance" style={{ borderTop: "1px solid black" }}>
        <td style={{ fontWeight: 700, border: "1px solid black" }} colSpan="3">
          Balance:
        </td>
        <td style={textTableRight}>
          {isCetakExcel === false
            ? totalPerTanggalDebet.toLocaleString("de-DE")
            : totalPerTanggalDebet}
        </td>
        <td style={textTableRight}>
          {isCetakExcel === false
            ? totalPerTanggalKredit.toLocaleString("de-DE")
            : totalPerTanggalKredit}
        </td>
        <td style={textTableRight}>
          {isCetakExcel === false
            ? runningSaldo.toLocaleString("de-DE")
            : runningSaldo}
        </td>
      </tr>
    );
  }

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanJurnalUmum",
    sheet: "LaporanJurnalUmum",
  });

  const { onDownloadNoBukti } = useDownloadExcel({
    currentTableRef: tableRefNoBukti.current,
    filename: "LaporanJurnalUmum",
    sheet: "LaporanJurnalUmum",
  });

  const { onDownload: onDownloadPerTanggal } = useDownloadExcel({
    currentTableRef: tableRefPerTanggal.current,
    filename: "LaporanJurnalUmum",
    sheet: "LaporanJurnalUmum",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Accounting</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Jurnal Umum</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />

      <FormControl sx={{ marginTop: 1 }}>
        <FormLabel id="demo-controlled-radio-buttons-group">Laporan</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          defaultValue="perAccount"
          value={value}
          onChange={handleChangeLaporan}
        >
          <FormControlLabel
            value="perAccount"
            control={<Radio />}
            label="Per Account"
          />
          <FormControlLabel
            value="perNoBukti"
            control={<Radio />}
            label="Per No Bukti"
          />
          <FormControlLabel
            value="perTanggal"
            control={<Radio />}
            label="Per Tanggal"
          />
        </RadioGroup>
      </FormControl>

      <Card>
        <Card.Header>Rentang Tanggal</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={tampilPdfPerAccount}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Dari :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={dariTanggal}
                      // minDate={new Date(user.tutupperiode.dariTanggal)}
                      // maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                      customInput={<Form.Control required />}
                      onChange={(date) => {
                        setDariTanggal(date);
                        setPreviewPdf(false);
                        setPreviewPdfNoBukti(false);
                        setPreviewPdfPerTanggal(false);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Sampai :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={sampaiTanggal}
                      // minDate={new Date(user.tutupperiode.dariTanggal)}
                      // maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                      customInput={<Form.Control required />}
                      onChange={(date) => {
                        setSampaiTanggal(date);
                        setPreviewPdf(false);
                        setPreviewPdfNoBukti(false);
                        setPreviewPdfPerTanggal(false);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="contained"
                startIcon={<PrintIcon />}
                type="submit"
              >
                TAMPIL PDF
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div
        ref={reportTemplateRef}
        id="content"
        style={{ ...pdfContainer, display: previewPdf ? "block" : "none" }}
      >
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${nowDate.getSeconds()} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Jurnal Umum Per Account
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${dariTanggal.getFullYear()} `}
            S/D :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${sampaiTanggal.getFullYear()}`}
          </p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={tableTitle}>Tg.</th>
                <th style={tableTitle}>No. Bukti</th>
                <th style={tableTitle}>Keterangan Jurnal</th>
                <th style={tableTitleRight}>Debet</th>
                <th style={tableTitleRight}>Kredit</th>
                <th style={tableTitleRight}>Saldo</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>

      {previewPdfNoBukti && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDFNoBukti}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownloadNoBukti();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div
        ref={reportTemplateRefNoBukti}
        id="content"
        style={{
          ...pdfContainer,
          display: previewPdfNoBukti ? "block" : "none",
        }}
      >
        <div
          style={{
            visibility: previewPdfNoBukti === true ? "visible" : "hidden",
          }}
        >
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${nowDate.getSeconds()} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Jurnal Umum Per No. Bukti
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${dariTanggal.getFullYear()} `}
            S/D :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}-${sampaiTanggal.getFullYear()}`}
          </p>
          <table class="styled-table" ref={tableRefNoBukti}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>Tg.</th>
                <th style={{ border: "1px solid black" }}>No. Bukti</th>
                <th style={{ border: "1px solid black" }}>Keterangan Jurnal</th>
                <th style={{ border: "1px solid black" }}>Debet</th>
                <th style={{ border: "1px solid black" }}>Kredit</th>
                <th style={{ border: "1px solid black" }}>Saldo</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>

      {previewPdfPerTanggal && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDFPerTanggal}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownloadPerTanggal();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div
        ref={reportTemplateRefPerTanggal}
        id="content"
        style={{
          ...pdfContainer,
          display: previewPdfPerTanggal ? "block" : "none",
        }}
      >
        <div
          style={{
            visibility: previewPdfPerTanggal === true ? "visible" : "hidden",
          }}
        >
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Jurnal Umum Per Tanggal
          </h5>
          <p>
            Dari Tanggal : {dariTanggal.toLocaleDateString("id-ID")} S/D : {sampaiTanggal.toLocaleDateString("id-ID")}
          </p>
          <table class="styled-table" ref={tableRefPerTanggal}>
            <thead>
              <tr>
                <th style={tableTitle}>Tg.</th>
                <th style={tableTitle}>No. Bukti</th>
                <th style={tableTitle}>Keterangan Jurnal</th>
                <th style={tableTitleRight}>Debet</th>
                <th style={tableTitleRight}>Kredit</th>
                <th style={tableTitleRight}>Saldo</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>

      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default LaporanJurnalUmum;

const subTitleText = {
  fontWeight: "900",
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const tableTitle = {
  padding: "10px",
  border: "1px solid black",
};

const tableTitleRight = {
  padding: "10px",
  textAlign: "right",
  border: "1px solid black",
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
};
